import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ExtractMaterialSlot} from "@cm/template-nodes"
import {SelectionPossibilities, ValueSlotComponent} from "@template-editor/components/value-slot/value-slot.component"
import {transformMaterialSlotTypeSelectionPossibilities} from "@template-editor/components/inspectors/blend-material-slot-inspector/blend-material-slot-inspector.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-extract-material-slot-inspector",
    templateUrl: "./extract-material-slot-inspector.component.html",
    styleUrl: "./extract-material-slot-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class ExtractMaterialSlotInspectorComponent extends BaseInspectorComponent<ExtractMaterialSlot, object> {
    readonly $slotPossibilities = signal<SelectionPossibilities<ExtractMaterialSlot["parameters"]["slot"]>>(transformMaterialSlotTypeSelectionPossibilities)
}
